import { collection, getFirestore, orderBy, query } from 'firebase/firestore';
import { firebaseApp } from '../../config/firebase.config';

const templateFormSchemaRef = (template: string) =>
  query(collection(getFirestore(firebaseApp), `templates/${template}/form-schema`), orderBy('position', 'asc'));

export default templateFormSchemaRef;
